import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { api } from "../api";
import { useSession } from "../session";
import { ErrorNotice, Mark } from "../ui";

export function SignIn() {
  const { me, refresh } = useSession();
  const [params] = useSearchParams();
  // Same rule as the server: a path on this site only (no "//", no backslashes), so a crafted
  // link can't send someone elsewhere after they sign in.
  const asked = params.get("returnTo") ?? "/";
  const returnTo = /^\/(?![\/\\])[^\s\\\u0000-\u001f\u007f]*$/.test(asked) ? asked : "/";
  const [options, setOptions] = useState<{ oidc: boolean; devLogin: boolean } | null>(null);
  const [name, setName] = useState("");
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    api.get<{ oidc: boolean; devLogin: boolean }>("/auth/options").then(setOptions).catch(setError);
  }, []);

  // Server routes (e.g. finishing the iPhone app's sign-in) need a full page load.
  if (me && returnTo.startsWith("/auth/")) {
    window.location.assign(returnTo);
    return null;
  }
  if (me) return <Navigate to={returnTo} replace />;

  return (
    <div className="center-page">
      <div className="signin stack" style={{ "--gap": "20px" } as React.CSSProperties}>
        <div className="row" style={{ justifyContent: "center" }}><Mark /><h1>TaxApp</h1></div>
        <p className="muted">Your tax records, receipts and returns — private to you and the people you choose.</p>
        <ErrorNotice error={error} />
        {options?.oidc && (
          <a className="btn primary large" href={`/auth/login?returnTo=${encodeURIComponent(returnTo)}`}>Sign in</a>
        )}
        {options?.devLogin && (
          <form
            className="card flat stack"
            onSubmit={async (event) => {
              event.preventDefault();
              try {
                await api.post("/auth/dev-login", { name });
                await refresh();
              } catch (e) {
                setError(e);
              }
            }}
          >
            <div className="pill warn" style={{ alignSelf: "center" }}>Development sign-in</div>
            <div className="field">
              <label htmlFor="dev-name">Name</label>
              <input id="dev-name" type="text" value={name} onChange={(e) => setName(e.target.value)} required autoFocus />
            </div>
            <button className="btn" type="submit">Continue</button>
          </form>
        )}
        {options && !options.oidc && !options.devLogin && (
          <div className="notice">Sign-in isn't configured on this server yet.</div>
        )}
      </div>
    </div>
  );
}
